import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.updateCatalogForm.title, 'Update catalog'),
  description: () => __(translations.updateCatalogForm.description, 'This action will update catalog status for selected variants'),
};
